import { UIComponentViewImpl } from '../uicomponentview';
import * as React from 'react';
import { GenericTabComponentProps, GenericTabComponentState, GenericTabComponentHandler } from './generictabcomponent';
import { GenericTabCSSStyle } from './generictabcss';
import './generic-tab-style.css';

export class GenericTabViewImpl<T> extends UIComponentViewImpl<T>
{
    bindHandlers()
    {
        this.onTabSelected = this.onTabSelected.bind(this);
    }

    draw(props: GenericTabComponentProps, state: GenericTabComponentState, cssStyle: GenericTabCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return(
          <>
          {/* {
            this.getWebView(props,state, cssStyle)
        } */}
                <div id="generic-tab-web" style={{width: "100%"}}>
                    {
                        this.getWebView(props,state, cssStyle)
                    }
                </div> 
               
                <div id="generic-tab-mobile" style={{width: "100%"}}>
                    {
                        this.getMobileView(props,state, cssStyle)
                    }
                </div>
                <div style={cssStyle.getTabContentCSSStyle()}>
                    {
                        state.selectedTabContent
                    }
                </div>
            </>
            
       );
    }

    getWebView(props: GenericTabComponentProps, state: GenericTabComponentState, cssStyle: GenericTabCSSStyle)
    {
        return (
          <div style={cssStyle.getWrapperCSSStyle()}>
              <div style={cssStyle.getTabHeaderCSSStyle()}>
                <div id="generic-tab-title" style={cssStyle.getHeaderTitleDivCSSStyle()}>
                  <label style={cssStyle.getHeaderTitleCSSStyle()}>{props.headerTitle}</label>
                </div>
                {
                      props.genericTabViewModel.getListOfTitles().map((entry: any, index: number)=>
                      {
                        return <>
                                  <label key={index} onClick={() =>this.onTabSelected(entry)} style={cssStyle.getTabLinkCSSStyle(state.selectedTabTitle === entry)}>{entry}</label>
                                  {
                                    (props.genericTabViewModel.getListOfTitles().length - 1) !== index &&
                                    <div style={cssStyle.getPipeCSSStyle()}>
                                      {"|"}
                                  </div>
                                  }
                              </>;
                      })
                }
              </div>
                 
            </div>
        );
    }


    getMobileView(props: GenericTabComponentProps, state: GenericTabComponentState, cssStyle: GenericTabCSSStyle)
    {
        return (
          <div style={cssStyle.getMobileWrapperCSSStyle()}>
              <div style={cssStyle.getMobileTabHeaderCSSStyle()}>
                <div id="generic-tab-title" style={cssStyle.getMobileHeaderTitleDivCSSStyle()}>
                  <label style={cssStyle.getMobileHeaderTitleCSSStyle()}>{props.headerTitle}</label>
                </div>
                {
                      props.genericTabViewModel.getListOfTitles().map((entry: any, index: number)=>
                      {
                        return <>
                                  <label key={index} onClick={() =>this.onTabSelected(entry)} style={cssStyle.getMobileTabLinkCSSStyle(state.selectedTabTitle === entry)}>{entry}</label>
                                  {
                                    (props.genericTabViewModel.getListOfTitles().length - 1) !== index &&
                                    <div style={cssStyle.getPipeCSSStyle()}>
                                      {"|"}
                                  </div>
                                  }
                              </>;
                      })
                }
              </div>
                  
            </div>
        );
    }

    private onTabSelected(title: string): void
    {
        (this.getUIComponentHandler() as GenericTabComponentHandler).onTabSelected(title);
    }
}

{/* <button class="tablink" onclick="openPage('Home', this, 'red')">Home</button>
<button class="tablink" onclick="openPage('News', this, 'green')" id="defaultOpen">News</button>
<button class="tablink" onclick="openPage('Contact', this, 'blue')">Contact</button>
<button class="tablink" onclick="openPage('About', this, 'orange')">About</button>

<div id="Home" class="tabcontent">
  <h3>Home</h3>
  <p>Home is where the heart is..</p>
</div>

<div id="News" class="tabcontent">
  <h3>News</h3>
  <p>Some news this fine day!</p> 
</div>

<div id="Contact" class="tabcontent">
  <h3>Contact</h3>
  <p>Get in touch, or swing by for a cup of coffee.</p>
</div>

<div id="About" class="tabcontent">
  <h3>About</h3>
  <p>Who we are and what we do.</p>
</div> */}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/tabs/generictabview.tsx